import React from 'react';
import styles from './NoiseOverlay.module.css';

export default function NoiseOverlay() {
  return <div className={styles.noiseOverlay} aria-hidden="true" />;
}
